import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GalleryContentFormComponent } from './gallery-content-form/gallery-content-form.component';
import { GalleryContentRoutingModule } from './gallery-content-routing.module';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [GalleryContentFormComponent],
  imports: [
    CommonModule,
    GalleryContentRoutingModule,
    SharedModule,
    SharedFormSectionsModule,
    MatSnackBarModule,
    MatDialogModule,
  ],
})
export class GalleryContentModule {}
